import React from "react";
import {createStore} from "redux";
import {Provider} from "react-redux";
import {composeWithDevTools} from "redux-devtools-extension";
import DevLogApp from "./reducers";
import Routes from "./routers";
import HttpsRedirect from 'react-https-redirect';

// create store
const store = createStore(
    DevLogApp,
    composeWithDevTools()
);

function App() {
    return (
        <Provider store={store}>
            <HttpsRedirect>
                <Routes/>
            </HttpsRedirect>
        </Provider>
    );
}

export default App;